/**
 * Script for All Pages
 *
 * @author Good Graphic Inc.
 * @version 2024-02-13
 */

/**
 * Minimum Viewport (JS)
 *
 * @author Good Graphic Inc.
 * @version 2022-10-18
 */

(() => {
    const MIN_WIDTH = 360;

    const vp = document.querySelector('meta[name="viewport"]');
    function fn() {
        const v = window.outerWidth > MIN_WIDTH ? "width=device-width,initial-scale=1" : `width=${MIN_WIDTH}`;
        if (vp.getAttribute("content") !== v) {
            vp.setAttribute("content", v);
        }
    }
    addEventListener("resize", throttle(fn), false);
    fn();

    /**
     * Throttling Function
     *
     * @author Good Graphic Inc.
     * @version 2022-10-13
     */
    
    function throttle(fn) {
        let isRunning;
        return (...args) => {
            if (isRunning) return;
            isRunning = true;
            requestAnimationFrame(() => {
                isRunning = false;
                fn(...args);
            });
        };
    }
    
})();

/**
 * Scroll To Top
 *
 * @author Good Graphic Inc.
 * @version 2024-02-09
 */


(() => {
    function init() {
        const btn = document.getElementById("scroll-to-top");
        if (!btn) return;

        const offset = parseInt(btn.dataset.offset ?? "0");

        // 常に fixed（切替しない）
        btn.classList.add("fixed");
        btn.style.transform = `translate3d(0, -${offset}px, 0)`;

        // 表示・非表示（ここは scrollY だけなので安全）
        window.addEventListener(
            "scroll",
            () => {
                if (window.scrollY > window.innerHeight / 3) {
                    btn.classList.remove("hidden");
                } else {
                    btn.classList.add("hidden");
                }
            },
            { passive: true }
        );

        // --- sentinel を JS で生成 ---
        const sentinel = document.createElement("div");
        sentinel.style.position = "absolute";
        sentinel.style.bottom = "0";
        sentinel.style.height = "1px";
        sentinel.style.width = "1px";
        sentinel.style.pointerEvents = "none";

        document.body.appendChild(sentinel);

        // --- IntersectionObserver ---
        const io = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    const y = entry.boundingClientRect.height + offset;
                    btn.style.transform = `translate3d(0, -${y}px, 0)`;
                } else {
                    btn.style.transform = `translate3d(0, -${offset}px, 0)`;
                }
            },
            {
                root: null,
                threshold: 0,
            }
        );

        io.observe(sentinel);

        btn.addEventListener("click", () => {
            window.scroll({ top: 0, behavior: "smooth" });
        });
    }

    document.addEventListener("DOMContentLoaded", init);
})();

/**
 * Search Popup (JS)
 *
 * @author Good Graphic Inc.
 * @version 2024-02-13
 */

document.addEventListener("DOMContentLoaded", () => {
    const btn = document.querySelector("#btn-search-popup");
    const pcPopup = document.querySelector("#search-popup");
    const closeBtn = document.querySelector("#btn-search-popup-close");

    const mql = window.matchMedia("(max-width: 899px)");

    const closePcPopup = () => {
        btn?.classList.remove("open");
        pcPopup?.classList.remove("open");
    };

    const syncOpenState = () => {
        // menusimplex は 900px をまたぐたびに #search-popup-sp の複製(data-merged-clone)を
        // destroy → 再生成するため、NodeList をキャッシュせず毎回取得し直す
        document.querySelectorAll("#search-popup-sp").forEach((popup) => {
            popup.classList.toggle("open", mql.matches);
        });

        if (!mql.matches) {
            closePcPopup();
        }
    };

    syncOpenState();
    // menusimplex 側のモード切り替え(クローン再生成)が同じ change イベントで
    // 先に完了してから参照するため、次のタスクにずらして実行する
    mql.addEventListener("change", () => setTimeout(syncOpenState, 0));

    if (btn && pcPopup) {
        btn.addEventListener("click", () => {
            if (mql.matches) return;
            btn.classList.toggle("open");
            pcPopup.classList.toggle("open");
        });
    }

    closeBtn?.addEventListener("click", closePcPopup);
});

/**
 * Toggle Button
 *
 * @author Good Graphic Inc.
 * @version 2023-02-21
 */

document.addEventListener("DOMContentLoaded", () => {
    const btns = document.querySelectorAll('.user-content *[class^="button"]');

    for (let i = 0; i < btns.length; i += 1) {
        if (isToggleButton(btns[i])) setEventListener(btns[i]);
    }

    function isToggleButton(btn) {
        if (!btn.href || btn.href[btn.href.length - 1] !== "#") return false;
        const p = btn.parentElement;
        const f = p.nextElementSibling;
        return f.classList.contains("frame") || f.classList.contains("frame-alt");
    }

    function setEventListener(btn) {
        btn.classList.add("toggle");
        initFrame(btn);
        btn.addEventListener("click", (e) => {
            if (btn.classList.contains("active")) {
                btn.classList.remove("active");
                setFrameVisible(btn, false);
            } else {
                btn.classList.add("active");
                setFrameVisible(btn, true);
            }
            e.preventDefault();
        });
    }

    function initFrame(btn) {
        const p = btn.parentElement;
        const f = p.nextElementSibling;
        f.style.display = "none";
        f.classList.add("hidden");
        setTimeout(() => {
            f.style.display = "";
        }, 10);
    }

    function setFrameVisible(btn, visible) {
        const p = btn.parentElement;
        const f = p.nextElementSibling;
        if (visible) {
            f.classList.remove("hidden");
        } else {
            f.classList.add("hidden");
        }
    }
});

/**
 * Scroll To Top
 *
 * @author Good Graphic Inc.
 * @version 2025-10-14
 */

document.addEventListener("DOMContentLoaded", function () {
    const btn = document.querySelector(".lang-switch-button");
    if (!btn) return;

    const url = btn.href;

    // HEAD リクエストで存在チェック
    fetch(url, { method: "HEAD" })
        .then((response) => {
            if (!response.ok) {
                // 404 などステータスがOKでない場合
                btn.classList.add("disable");
                btn.addEventListener("click", (e) => e.preventDefault());
            }
        })
        .catch(() => {
            // ネットワークエラー時も無効化
            btn.classList.add("disable");
            btn.addEventListener("click", (e) => e.preventDefault());
        });
});

/**
 * Search Popup (JS)
 *
 * @author Good Graphic Inc.
 * @version 2025-12-09
 */

(() => {
  const buttons = document.querySelectorAll('.menu-bar-full button');
  const panels  = document.querySelectorAll('.menu-panels > div');
  const menuWrapper = document.querySelector('.menu-panels');
  const barFull = document.querySelector('.menu-bar-full');

  // barFullがなければreturn
  if (!barFull) return;

  // -----------------------
  // 横スクロール可能か判定
  // -----------------------
  const updateScrollHint = () => {
    const canScroll = barFull.scrollWidth > barFull.clientWidth;
    barFull.classList.toggle('has-scroll', canScroll);
  };

  updateScrollHint();
  window.addEventListener('resize', updateScrollHint);

  // -----------------------
  // ボタンクリックでパネル操作（トグル対応）
  // -----------------------
  buttons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();

      const targetId = btn.dataset.panel;
      const targetPanel = document.getElementById(targetId);

      // ---- すでに開いているパネルを再クリックした場合（トグル） ----
      const isAlreadyOpen = targetPanel.classList.contains('is-open');

      // いったん全て閉じる
      panels.forEach(panel => panel.classList.remove('is-open'));
      buttons.forEach(b => b.classList.remove('is-active'));

      if (!isAlreadyOpen) {
        // パネルが閉じていた → 開く
        targetPanel.classList.add('is-open');
        btn.classList.add('is-active');
      }

      // パネル開閉後にスクロール判定を更新
      updateScrollHint();
    });
  });

  // -----------------------
  // パネル内部クリックは閉じない
  // -----------------------
  menuWrapper.addEventListener('click', (e) => {
    e.stopPropagation();
  });

  // -----------------------
  // 外側クリックで閉じる
  // -----------------------
  document.addEventListener('click', () => {
    panels.forEach(panel => panel.classList.remove('is-open'));
    buttons.forEach(btn => btn.classList.remove('is-active'));
  });
})();
/**
 * Archive Filter - Multiple Category Selection
 *
 * @author Good Graphic Inc.
 */

(() => {
    const asides = document.querySelectorAll(".part-archive-filter-products");

    for (const aside of asides) {
        const taxonomy = aside.dataset.taxonomy;
        const archiveUrl = aside.dataset.archiveUrl;
        const buttons = aside.querySelectorAll(".filter-btn");
        const allBtn = aside.querySelector(".btn-filter-all");
        const applyBtn = aside.querySelector(".btn-filter-apply");
        const clearBtn = aside.querySelector(".btn-filter-clear");

        const updateSelectionState = () => {
            const hasActive = [...buttons].some((b) => b.classList.contains("active"));

            if (clearBtn) clearBtn.hidden = !hasActive;

            if (allBtn) {
                allBtn.classList.toggle("active", !hasActive);
                allBtn.setAttribute("aria-pressed", hasActive ? "false" : "true");

                const allLi = allBtn.closest("li");
                if (allLi) allLi.classList.toggle("active", !hasActive);
            }
        };

        for (const btn of buttons) {
            btn.addEventListener("click", () => {
                const active = btn.classList.toggle("active");
                btn.setAttribute("aria-pressed", active ? "true" : "false");

                const li = btn.closest("li");
                if (li) li.classList.toggle("active", active);

                updateSelectionState();
            });
        }

        if (allBtn && archiveUrl) {
            allBtn.addEventListener("click", () => {
                window.location.href = archiveUrl;
            });
        }

        if (applyBtn && taxonomy && archiveUrl) {
            applyBtn.addEventListener("click", () => {
                const slugs = [...buttons]
                    .filter((b) => b.classList.contains("active"))
                    .map((b) => b.dataset.slug);

                const url = new URL(archiveUrl, window.location.origin);
                if (slugs.length) {
                    url.searchParams.set(taxonomy, slugs.join(","));
                }
                window.location.href = url.toString();
            });
        }

        if (clearBtn && archiveUrl) {
            clearBtn.addEventListener("click", () => {
                window.location.href = archiveUrl;
            });
        }
    }
})();



function updateScrollbarPadding() {
  const hasScrollbar =
    window.innerWidth > document.documentElement.clientWidth;

  document.documentElement.style.setProperty(
    '--scrollbar-width',
    hasScrollbar ? '31px' : 'max(2vw, 1rem)'
  );
}

updateScrollbarPadding();
window.addEventListener('resize', updateScrollbarPadding);